import { createSelector } from 'reselect'
import carlinesRequestIsPendingSelector from '../pending-request/carlinesRequestIsPendingSelector'

const carlineSelectionIsLoadingSelector = createSelector(
    carlinesRequestIsPendingSelector,
    (carlinesRequestIsPending): boolean => carlinesRequestIsPending,
)

export default carlineSelectionIsLoadingSelector
